import { CANCEL_CELL_EDIT_VALUE } from "components/ToolEditor/constants";
import { ToolEditorResultRowCellEditorParams } from "../ResultsEditor";
import { MultiStringEditor } from "components/ToolEditor/components/MultiStringEditor";

/**
 * Cell editor for file patterns
 */
export const FilePatternEditor = ({
  data,
  onValueChange,
  stopEditing,
}: ToolEditorResultRowCellEditorParams) => {
  const onClose = (cancel?: boolean) => {
    if (cancel) {
      onValueChange(CANCEL_CELL_EDIT_VALUE);
    }
    stopEditing(cancel);
  };

  return (
    <MultiStringEditor
      initialValue={data.file_patterns}
      onClose={onClose}
      onValueChange={onValueChange}
    />
  );
};
